import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '🎯',
      title: 'Consulting',
      description: 'Strategic business consulting to help you make informed decisions and achieve your goals.'
    },
    {
      icon: '💻',
      title: 'Technology Solutions',
      description: 'Cutting-edge technology services including software development and IT infrastructure.'
    },
    {
      icon: '📊',
      title: 'Digital Marketing',
      description: 'Comprehensive digital marketing strategies to boost your online presence and reach.'
    },
    {
      icon: '🏗️',
      title: 'Project Management',
      description: 'Expert project management services ensuring timely delivery and quality results.'
    },
    {
      icon: '🔧',
      title: 'Maintenance & Support',
      description: '24/7 support and maintenance services to keep your operations running smoothly.'
    },
    {
      icon: '📈',
      title: 'Business Analytics',
      description: 'Data-driven insights and analytics to optimize your business performance.'
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Comprehensive solutions tailored to your business needs
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
